module.exports = __webpack_public_path__ + "img/step38_b_printer_power_remove_retainers_close_roll_cover.a2ecbf7c.png";